export default "__VITE_ASSET__BBfhofqc__"